import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
// import mapGetters from './getters'

Vue.use(Vuex)

// const mutations = {
//   [Types.INCREMENT] (state, amount) {
//       state.count = state.count + amount;
//       return true;
//   },
//   [Types.DECREMENT] (state, amount) {
//       if (state.count < amount) return false;
//       state.count = state.count - amount;
//       return true;
//   }
// }

const state = {
  showStyle: 1,
  columnId: "",
  labelIds: "",
}

export default new Vuex.Store({
  getters,
  state,
})

